<template>
  <div>
    <!-- 封面 -->
    <a-row class="cover">
      <a-col class="container" :xs="{ span: 24, offset: 0 }" :xxl="{ span: 16, offset: 4 }">

        <a-col :lg="24" :xl="9" :xxl="9">
          <!-- APP名称 -->
          <div class="app-head">
            <img class="app-logo" src="~@/assets/real-name-assistant/introduce/app_logo.png" alt="app_logo">
            <h2 class="title-level1" style="color: white;">鱼宿</h2>
          </div>
          <!-- APP描述 -->
          <div class="text-level1" style="color: white;">
            【鱼宿】是《成都鱼住未来科技有限公司》打造的<span class="stress">民宿网约房经营管理系统，</span>系统针对<span class="stress">民宿网约房“不见面模式”实名登记与难题，</span>门锁前自主完成人脸证件二合一核验并授权进入房间，实时采集登记信息并上传入住系统。
          </div>
          <!-- 下载部分，屏宽小于1200px时隐藏 -->
          <a-col :xs="0" :xl="24">
            <div class="app-download">
              <img class="app_qrcode" src="~@/assets/real-name-assistant/introduce/app_qrcode.png" alt="app_qrcode">
              <p class="app-version">{{time}} 版本：V{{version}}</p>
              <a-button class="download-btn" type="link" shape="round" @click="handlerDownloadAPK">点击下载APP</a-button>
            </div>
          </a-col>
          <!-- 下载部分，屏宽小于1200px时显示 -->
          <a-col :lg="24" :xl="0">
            <!-- 屏宽小于1200px时占10份，小于576px时占24份 -->
            <a-col :xs="24" :sm="10">
              <div class="app-download">
                <img class="app_qrcode" src="~@/assets/real-name-assistant/introduce/app_qrcode.png" alt="app_qrcode">
                <p class="app-version">{{time}} 版本：V{{version}}</p>
                <p class="app-version">扫描二维码下载鱼宿APP</p>
<!--                <a-button class="download-btn" type="primary" shape="round" @click="handlerDownloadAPK">点击下载APP-->
<!--                </a-button>-->
              </div>
            </a-col>
            <!-- 屏宽小于1200px时占14份，小于576px时隐藏 -->
            <a-col :xs="0" :sm="14">
              <div class="image-computer-phone"></div>
            </a-col>
          </a-col>
        </a-col>
        <!-- 右边配图，屏宽小于1200px时隐藏 -->
        <a-col :xs="0" :xl="15" :xxl="14">
          <div class="image-box">
            <img class="image-phone" src="~@/assets/real-name-assistant/introduce/phone.png" alt="phone">
          </div>
        </a-col>
      </a-col>
    </a-row>

    <!-- 特色功能 -->
    <a-row class="function-points">
      <a-col class="container" :xs="{ span: 24, offset: 0 }" :xxl="{ span: 16, offset: 4 }">
        <h2 class="title-level2" style="text-align: center;">{{datas.functionPoints.title}}</h2>
        <p class="text-level1" style="text-align: center;">{{datas.functionPoints.subTitle}}</p>

        <a-row type="flex" justify="space-between" style="margin: 50px 0">
          <div class="function-box" v-for="item in datas.functionPoints.points" :key="item.title">
            <img class="icon" :src="require(`@/assets/real-name-assistant/introduce/${item.pic}`)" :alt="item.pic">
            <h4 class="title-level4">{{item.title}}</h4>
            <p class="text-level2" style="color: #999;">{{item.describe}}</p>
          </div>
        </a-row>
      </a-col>
    </a-row>

    <!-- 使用流程 -->
    <a-row class="process">
      <a-col class="container" :xs="{ span: 24, offset: 0 }" :xxl="{ span: 16, offset: 4 }">
        <h2 class="title-level2" style="color: white;text-align: center;">{{datas.process.title}}</h2>
        <p class="text-level1" style="color: white;text-align: center;">{{datas.process.subTitle}}</p>

        <a-row type="flex" justify="space-between" style="margin: 50px 0">
          <div v-for="(item, index) in datas.process.steps" :key="index" :class="item.title ? 'step-box' : 'step-deco'">
            <template v-if="item.title">
              <img class="icon" :src="require(`@/assets/real-name-assistant/introduce/${item.pic}`)" :alt="item.pic">
              <h4 class="title-level4" style="color: white;text-align: center;">{{item.title}}</h4>
              <p class="text-level2" style="color: white;text-align: center;">{{item.describe}}</p>
            </template>
            <template v-else>
              <img class="deco-icon" :src="require(`@/assets/real-name-assistant/introduce/${item.pic}`)"
                :alt="item.pic">
              <div class="deco-line"></div>
            </template>
          </div>
        </a-row>
      </a-col>
    </a-row>

    <!-- 适用行业 -->
    <a-row class="industry">
      <a-col class="container" :xs="{ span: 24, offset: 0 }" :xxl="{ span: 16, offset: 4 }">
        <h2 class="title-level2" style="text-align: center;">{{datas.industry.title}}</h2>
        <p class="text-level1" style="text-align: center;">{{datas.industry.subTitle}}</p>

        <a-row type="flex" justify="space-between" style="margin: 50px 0">
          <div class="industry-box" v-for="item in datas.industry.industries" :key="item.title"
            :style="item.reverse ? { 'flex-direction': 'row-reverse' } : ''">
            <div class="picture">
              <img :src="require(`@/assets/real-name-assistant/introduce/${item.pic}`)" :alt="item.pic">
            </div>
            <div class="info">
              <img class="icon" :src="require(`@/assets/real-name-assistant/introduce/${item.icon}`)" :alt="item.icon">
              <h4 class="title-level4" style="font-weight: normal;margin: 10px 0">{{item.name}}</h4>
              <p class="text text-level1" style="text-align: center;margin: 0">{{item.enName}}</p>
            </div>
          </div>
        </a-row>
      </a-col>
    </a-row>

    <PageFooter />
  </div>
</template>

<script>
import PageFooter from '../components/PageFooter.vue'
import datas from './datas.json'
// const baseUrl = '/product-introduce-yusu/download'
const version = '2.3.3'
// const AppDownload = `${baseUrl}/yusu${version}.apk`
const AppDownload = 'https://d.yzfuture.cn/p/29'

export default {
  name: 'RealNameAssistant-Introduce',
  components: { PageFooter },
  data () {
    return {
      datas,
      time: '2025-12-29',
      version
    }
  },
  computed: {},
  methods: {
    handlerDownloadAPK () {
      window.location.href = AppDownload
    },
    handleCLick () {
      this.$router.push({})
    }
  }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>
